import React from 'react';
import { createPortal } from 'react-dom';
import '../../DocsArea/Atlas/components/AtlasContextMenu.css';

const CampaignsAtlasContextMenu = ({
  ctx,
  onCreateRoot,
  onCreateNested,
  onOpen,
  onOpenInNewTab,
  onRename,
  onTrash,
  onClose,
}) => {
  if (!ctx) return null;
  const isCanvas = !ctx.folderId;
  return createPortal(
    <div
      className="atlas__ctx"
      style={{ left: ctx.x, top: ctx.y }}
      onClick={(e) => e.stopPropagation()}
    >
      {isCanvas && (
        <button type="button" onClick={() => { onCreateRoot?.(); onClose?.(); }}>
          New campaign
        </button>
      )}
      {!isCanvas && (
        <>
          <button type="button" onClick={() => { onOpen?.(ctx.folderId); onClose?.(); }}>
            Open
          </button>
          <button type="button" onClick={() => { onOpenInNewTab?.(ctx.folderId); onClose?.(); }}>
            Open in new tab
          </button>
          <button type="button" onClick={() => { onCreateNested?.(ctx.folderId); onClose?.(); }}>
            New nested campaign
          </button>
          <button type="button" onClick={() => { onRename?.(ctx.folderId); onClose?.(); }}>
            Rename
          </button>
          {onTrash && (
            <button
              type="button"
              className="atlas__ctx--danger"
              onClick={() => { onTrash(ctx.folderId); onClose?.(); }}
            >
              Move to trash
            </button>
          )}
        </>
      )}
    </div>,
    document.body
  );
};

export default CampaignsAtlasContextMenu;
